import SignaturePad from 'signature_pad';

import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {SignaturePadService} from "../../service/signature-pad.service";


@Component({
  selector: 'rg-signature-pad',
  templateUrl: './signature-pad.component.html',
})
export class SignaturePadComponent implements OnInit{

  @ViewChild('signatureWrapper', {static: true }) public signatureWrapperRef?: ElementRef;
  @ViewChild('canvas', {static: true }) public canvasRef?: ElementRef<HTMLCanvasElement>;

  constructor(public signaturePadService:SignaturePadService) {
  }

  public signaturePad?: SignaturePad;

  ngOnInit() {
    this.initSignaturePad();
  }

  clearSignaturePad(){
    this.signaturePad?.clear();
  }

  initSignaturePad(){
    if (this.canvasRef && this.signatureWrapperRef) {
      this.signaturePad = new SignaturePad(this.canvasRef.nativeElement);
      this.signaturePadService.update(this.signaturePad);
    }
  }

}
